import React, {FC, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap-v5'
import {showErrorToast, showSuccessToast} from '../../../../shared/components/ToastUtils'
import {apiErrorMessage} from '../../public/PublicModels'
import {formatDateTime} from '../shared/DocumentApi'
import {addInterviewNote, getInterview} from './Api'
import {IInterviewModel, IInterviewNote, interviewTimeRange} from './InterviewModel'

type Props = {
  interview: IInterviewModel | null
  onClose: () => void
  /** Not eklenince liste sayacını yenilemek için */
  onNoteAdded?: () => void
}

/** Mülakat notları: İK adayla ilgili notlarını alır, önceki notlar altta listelenir */
export const InterviewNotesModal: FC<Props> = ({interview, onClose, onNoteAdded}) => {
  const [notes, setNotes] = useState<IInterviewNote[]>([])
  const [loading, setLoading] = useState(false)
  const [text, setText] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!interview) return
    setText('')
    setNotes([])
    setLoading(true)
    getInterview(interview.id)
      .then(({data}) => setNotes(data.payload.notes || []))
      .catch((error) => showErrorToast(apiErrorMessage(error, 'Notlar yüklenemedi')))
      .finally(() => setLoading(false))
  }, [interview])

  const handleSave = async () => {
    if (!interview || !text.trim()) return
    setSaving(true)
    try {
      const {data} = await addInterviewNote(interview.id, text.trim())
      setNotes((current) => [data.payload, ...current])
      setText('')
      showSuccessToast('Not kaydedildi')
      onNoteAdded?.()
    } catch (error) {
      showErrorToast(apiErrorMessage(error, 'Not kaydedilemedi'))
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal show={!!interview} onHide={onClose} size='lg' dialogClassName='modal-dialog-centered'>
      <div className='modal-header'>
        <div>
          <h5 className='modal-title'>Mülakat Notları</h5>
          {interview && (
            <div className='text-muted fs-7'>
              {interview.candidateName} · {interview.jobTitle || interview.title} · {interviewTimeRange(interview)}
            </div>
          )}
        </div>
        <button type='button' className='btn-close' onClick={onClose} />
      </div>
      <div className='modal-body'>
        <textarea
          rows={5}
          maxLength={5000}
          className='form-control mb-3'
          placeholder='Adayla ilgili notlarınız...'
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <div className='d-flex justify-content-end mb-8'>
          <button type='button' className='btn btn-sm btn-primary' disabled={saving || !text.trim()} onClick={handleSave}>
            {saving ? <span className='spinner-border spinner-border-sm' /> : 'Notu Kaydet'}
          </button>
        </div>

        {loading ? (
          <div className='text-center py-5'>
            <span className='spinner-border text-primary' />
          </div>
        ) : notes.length === 0 ? (
          <div className='text-muted text-center py-5'>Henüz not eklenmemiş</div>
        ) : (
          <div className='d-flex flex-column gap-4'>
            {notes.map((note) => (
              <div key={note.id} className='border border-dashed border-gray-300 rounded p-4'>
                <div className='d-flex justify-content-between text-muted fs-8 mb-2'>
                  <span>
                    <i className='bi bi-person me-1'></i>
                    {note.authorName || '-'}
                  </span>
                  <span>{formatDateTime(note.createdDate)}</span>
                </div>
                <div style={{whiteSpace: 'pre-wrap'}}>{note.text}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  )
}
